import _ from "lodash";
export default {
  methods: {
    capitalize(string) {
      return _.capitalize(string).replace("_", " ");
    },
    validEmail(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    textEllipsis(text, length) {
      if (text.length <= length) {
        return text;
      } else {
        return text.substring(0, length) + "...";
      }
    }
  }
};
